<div class="customer-contact-item">
  <div class="customer">
    {{ customerLabel$ | async }}
  </div>
  <div class="role">
    ({{roleLabel$ | async}})
  </div>
</div>

